import { Component, OnInit } from '@angular/core';
import { TablaComponent } from '../../shared/components/tabla/tabla.component';
import { GithubService } from '../services/github-service.service';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { Ec2Repositories, IFullProject, IProjects } from '../../models';

@Component({
  selector: 'app-gdl',
  imports: [TablaComponent, ToolbarComponent],
  templateUrl: './gdl.component.html',
  styleUrl: './gdl.component.scss',
})
export class GdlComponent implements OnInit {
  repositories: Ec2Repositories = {};
  projects: IProjects = {};
  demo: IFullProject[] = [];

  constructor(readonly _githubService: GithubService) {}

  ngOnInit(): void {
    this.getRepositories();
  }

  async getRepositories(): Promise<void> {
    try {
      const response = await this._githubService.fetchRepositories();
      this.repositories = response.ec2Repositories;
    } catch (error) {
      console.error('Error fetching repositories:', error);
      throw error;
    } finally {
      await this.getContentRepositories();
    }
  }

  async getContentRepositories(): Promise<void> {
    try {
      const response = await this._githubService._fetchContentRepositories({
        ec2Repositories: this.repositories,
      });

      this.projects = response;
    } catch (error) {
      console.error('Error fetching repositories:', error);
      throw error;
    } finally {
      await this.getStackEOL();
    }
  }

  async getStackEOL(): Promise<void> {
    try {
      const response = await this._githubService._fetchContentStackEOL(
        this.projects,
      );

      this.demo = response;
    } catch (error) {
      console.error('Error fetching repositories:', error);
      throw error;
    }
  }
}
